import React from 'react';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';
import {
  dayjsFromApiUtcInTz,
  formatDateTimeFromDayjsInTzWithLocale,
} from '@utils/dateWithTz.tsx';

interface ComponentProps {
  dateTime: string;
  label: string;
  timezoneId: string;
}

const DateTimeBadge: React.FC<ComponentProps> = ({ dateTime, label, timezoneId }) => {
  return (
    <>
      {isNotNullOrUndefined(dateTime) && (
        <Badge filled={false} value={`${formatDateTimeFromDayjsInTzWithLocale(dayjsFromApiUtcInTz(dateTime,  timezoneId), timezoneId)}`} label={label}
               highlightedValue={false}></Badge>
      )}
    </>
  );
};

export default DateTimeBadge;
